
    const data = {"name":"src/core/icons/pencil-box","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-2.3 6.35c.22-.21.22-.56 0-.77L15.42 7.3a.532.532 0 0 0-.77 0l-1 1 2.05 2.05 1-1M7 14.94V17h2.06l6.06-6.06-2.06-2.06L7 14.94Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            